import { FC, memo } from 'react';

import Loader from 'components/Loader';

import { useBankOverviewSearchParams } from '../hooks/useBankOverviewSearchParams';
import Component from './component';
import Help from './Help';
import { useDetailedTransactionQuery } from './hooks/useDetailedTransactionQuery';

interface BankSidebarProps {
  transactionId: string;
}

const BankSidebar: FC<BankSidebarProps> = ({ transactionId }) => {
  const { error, loading, transaction } =
    useDetailedTransactionQuery(transactionId);

  const { showHelp } = useBankOverviewSearchParams();

  if (error || (!loading && !transaction)) {
    return <div>Une erreur est survenue.</div>;
  }

  if (loading || !transaction) {
    return <Loader />;
  }

  return showHelp ? (
    <Help transaction={transaction} />
  ) : (
    <Component transaction={transaction} />
  );
};

export default memo(BankSidebar);
